import { RadioButtonNew, RadioGroupNew } from "@octopusdeploy/design-system-components";
import { Permission, DashboardRenderMode } from "@octopusdeploy/octopus-server-client";
import type { PerformanceConfigurationResource, Repository } from "@octopusdeploy/octopus-server-client";
import { PageContent } from "~/components/PageContent/PageContent";
import { ExpandableFormSection, Summary } from "~/components/form";
import { Form, useForm } from "~/components/form/Form/Form";
export const performancePageTitle = "Performance";
interface PerformancePageLoaderData {
    performanceConfiguration: PerformanceConfigurationResource;
}
interface PerformancePageProps {
    loaderData: PerformancePageLoaderData;
}
export async function performancePageLoader(repository: Repository): Promise<PerformancePageLoaderData> {
    const performanceConfiguration = await repository.PerformanceConfiguration.get();
    return {
        performanceConfiguration,
    };
}
export function PerformancePage({ loaderData }: PerformancePageProps) {
    const { model, setModel, formProps, createSaveAction } = useForm({
        formName: "Update Performance Configuration",
        initialModel: loaderData.performanceConfiguration,
        onSubmit: (repository, performanceConfiguration) => repository.PerformanceConfiguration.modify(performanceConfiguration),
        updateFormModelAfterSubmit: (model) => model,
        snackbarSaveText: "Details updated",
        submitPermission: { permission: [Permission.ConfigureServer] },
    });
    const description = "Choose the default project overview rendering mode. Full rendering will render all rows, fast rendering will render only visible rows.";
    const label = "Project Overview Rendering";
    const name = "DefaultDashboardRenderMode";
    return (<PageContent header={{ primaryAction: createSaveAction({}), title: performancePageTitle }}>
            <Form {...formProps}>
                <ExpandableFormSection errorKey="DefaultDashboardRenderMode" title={label} focusOnExpandAll summary={model.DefaultDashboardRenderMode === DashboardRenderMode.VirtualizeColumns ? Summary.summary("Full project overview rendering") : Summary.summary("Fast project overview rendering")} help={description}>
                    <RadioGroupNew value={model.DefaultDashboardRenderMode} onChange={(DefaultDashboardRenderMode) => setModel((prev) => ({ ...prev, DefaultDashboardRenderMode }))} label={label} description={description} hideLabel={true} hideDescription={true}>
                        <RadioButtonNew value={DashboardRenderMode.VirtualizeColumns} label="Full render" name={name} hasDefaultMarker={true}/>
                        <RadioButtonNew value={DashboardRenderMode.VirtualizeRowsAndColumns} label="Fast render" name={name}/>
                    </RadioGroupNew>
                </ExpandableFormSection>
            </Form>
        </PageContent>);
}
